import { AppLayout } from 'App/AppLayout/AppLayout';
import { useAuth } from '@kitopi-com/customer-auth';
import { useAccessPoint } from 'context/AccessPointContext';
import { Navigate, Route, Routes } from 'react-router';
import { isLocalMode } from 'utils/constants';
import { LoginPage } from '../LoginPage/LoginPage';
import { SitesDashboard } from '../SitesTest/SitesDashboard ';
import { SuccessPage } from '../SuccessPage/SuccessPage';

interface AppRoutesProps {
  changeLanguage: (language: string) => void;
}

export const AppRoutes = ({ changeLanguage }: AppRoutesProps) => {
  const context = useAccessPoint();
  const { locale } = useAuth();

  const isSignedIn = context.isAuthorizedToAccessPoint;
  return (
    <Routes>
      <Route
        element={<AppLayout changeLanguage={changeLanguage} locale={locale} disableTranslations />}
      >
        <Route index element={<Navigate to={isSignedIn ? '/auth' : '/guest/s/:client'} />} />
        <Route path="/auth" element={<SuccessPage />} />

        <Route
          path="/sites-dashboard"
          element={isLocalMode ? <SitesDashboard /> : <Navigate to="/" />}
        />
        <Route path="/guest/s/:client" element={<LoginPage />} />
      </Route>
    </Routes>
  );
};
